import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";

// Create the context
const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
  const [exploreNow, setExploreNow] = useState(false);
  const [navbarExpanded, setNavbarExpanded] = useState(false);
  const [showMegaMenu, setShowMegaMenu] = useState({
    services: false,
    hireTeam: false,
  });
  const [dropdownTitleActive, setDropdownTitleActive] = useState("");
  const [activeTab, setActiveTab] = useState("Hire Team");
  const [selectedNavItem, setSelectedNavItem] = useState(null);
  const [tempSelectedTitle, setTempSelectedTitle] = useState("");
  const [ipAddress, setIpAddress] = useState("");

  // Define the context value
  const contextValue = {
    exploreNow,
    setExploreNow,
    showMegaMenu,
    setShowMegaMenu,
    navbarExpanded,
    setNavbarExpanded,
    dropdownTitleActive,
    setDropdownTitleActive,
    activeTab,
    setActiveTab,
    selectedNavItem,
    setSelectedNavItem,
    tempSelectedTitle,
    setTempSelectedTitle,
    ipAddress,
    setIpAddress,
  };
  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error("Error fetching IP address or blog data:", error);
      }
    };

    fetchIP();
  }, []); // Dependency array is empty, so this effect runs only once after the initial render

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};

// Custom hook to use the context
export const useAppContext = () => {
  return useContext(AppContext);
};
